import { createFileRoute, useNavigate } from '@tanstack/react-router';

import {
  applyStudioPatch,
  MetricStudioPage,
  toStudioLocation,
  validateStudioSearch,
} from '@/features/metric-studio';
import { isMarket, type Market } from '@/lib/market/types';

/**
 * =============================================================================
 *  `/:market/market/:metricKey` —— `grain='market'` 的同一個 Metric Studio。
 *
 *  後端是**同一支 handler**（§11.3「市場粒度的 PIT 時序（grain='market'）」），
 *  所以前端也是同一個元件。`symbol: null` 是這條路由與另外三條唯一的差別，
 *  而那個 null 一路傳到 `MetricStudioPage` 裡決定打哪一支端點——沒有第二個分支。
 * ========================================================================== */
export const Route = createFileRoute('/$market/market/$metricKey')({
  validateSearch: validateStudioSearch,
  component: MarketStudioRoute,
});

function MarketStudioRoute() {
  const { market: rawMarket, metricKey } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate();
  const market: Market = isMarket(rawMarket) ? rawMarket : 'tw';

  return (
    <MetricStudioPage
      location={toStudioLocation({ market, symbol: null, metricKey }, search)}
      onChange={(patch) => {
        void navigate({
          to: '.',
          search: (prev: Record<string, unknown>) => applyStudioPatch(prev, patch),
          replace: true,
          resetScroll: false,
        });
      }}
    />
  );
}
